console.log("Sticky JS loaded");

class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange.bind(this));
  }

  onStickyVariantChange() {
    const select = this.querySelector("select");
    const form = document.querySelector(`#product-sticky-form-${this.dataset.section}`);
    if (select && form) {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = select.value;
      }
    }
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

// Sticky bar on scroll
const stickyScroll = () => {
  const stickySelectedVariant = document.querySelector(`#sticky__variant`);
  if (stickySelectedVariant) {
    const stickyInput = document.querySelector("#sticky__selected_variant_id");
    if (stickyInput) stickyInput.value = stickySelectedVariant.value;
  }

  const BuyButtonForm = document.querySelector("product-form");
  const productStickyWrapper = document.querySelector(".product__sticky");

  if (!BuyButtonForm || !productStickyWrapper) return;

  window.addEventListener("scroll", () => {
    const top = BuyButtonForm.getBoundingClientRect().top + window.scrollY;
    if (window.scrollY > top) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  });
};

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", stickyScroll);
  document.addEventListener("shopify:section:select", stickyScroll);
  document.addEventListener("shopify:section:deselect", stickyScroll);
}

document.addEventListener("DOMContentLoaded", () => {
  stickyScroll();

  // Updated Quantity buttons logic — update form's quantity input only
  document.querySelectorAll('.product__sticky .quantity__button').forEach(button => {
    button.addEventListener('click', function () {
      const form = document.querySelector('[id^="product-sticky-form-"]');
      if (!form) return;

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      let value = parseInt(quantityInput.value) || 1;
      if (this.name === 'plus') value++;
      else if (this.name === 'minus' && value > 1) value--;

      quantityInput.value = value;

      // Sync the visible quantity input for UI
      const visibleInput = this.parentElement.querySelector('.quantity__input');
      if (visibleInput) visibleInput.value = value;
    });
  });

  // Initialize ProductForm if available
  const stickyProductForm = document.querySelector('[id^="product-sticky-form-"]');
  if (stickyProductForm && typeof ProductForm !== "undefined") {
    new ProductForm(stickyProductForm);
  }
});